module.exports = __webpack_public_path__ + "media/images/recruit/mv/img-mark-07-0fc997e6ac1efe63d31cb9f8157f73ac.svg";